import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { fetchContraList } from "./contraThunks";
import ContraList from "./components/ContraList";

const { Title } = Typography;

const ContraEntry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { contra } = useSelector((state) => state.contra);

  useEffect(() => {
    dispatch(fetchContraList());
  }, [dispatch]);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="contra-entry-back-button"
        />
        <Title level={2} style={{ margin: 0 }}>Contra Entry</Title>
      </div>
      <ContraList contraList={contra} />
    </>
  );
};

export default ContraEntry;
